//提示语
import { showToast } from "vant";


export const showMsg = (title: string, target?: string, position?: string) => {
    const options: any = {
        message: title,
        teleport: '',
        zIndex: 999999,
        position: 'middle',
        duration: 2500
    }
    if (target) {
        options.teleport = target
    }
    if (position) {
        options.position = position
    }
    showToast(options);
}



// 提交表单提示
export const fromShowMsg = (
    title: string,
    icon?: string,
    target?: string,
    position?: string
) => {
    const options: any = {
        message: title, 
        teleport: '',
        zIndex: 999999,
        position: 'middle',
        duration: 2500,
        icon: '',
        iconPrefix: undefined,
        className:'from-toast'
    }

    // 判断传入是 success 或 error
    if (icon === 'success') {
        options.icon = '/static/images/icon-susses.png'
        options.iconPrefix = 'img'
    } else if (icon === 'err') {
        options.icon = '/static/images/icon-err.png'
        options.iconPrefix = 'img'
    }

    if (target) {
        options.teleport = target
    }
    if (position) {
        options.position = position
    }

    showToast(options)
}